/* TwoClickAppInstallSiteAndPlanSelector.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { parse as parseAri } from '@atlassian/cs-ari';
import { isFreeApp } from '@atlassian/mpac-api-client';
import { MultiInstancePricingSectionMessage, PlanSelector, ScreenTitle } from '@atlassian/mpac-installation';
import { BodySmall } from '@atlassian/mpac-primitives';
import { useLinkTemplates } from '../hooks/useLinkTemplates';
import { SandBoxSectionMessage } from '../utils/SandBoxSectionMessage';
import { SiteSelectorSelect } from './SiteSelectorSelect';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "@media (min-width:48rem){._19wgxy5q{gap:var(--ds-space-400,2pc)}}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _2 = "@media not all and (min-width:48rem){._1s6bukr8{margin:var(--ds-space-negative-400,-2pc)}}";
const _ = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const siteSelectorScreenStyles = null;
const siteSelectorContentStyles = null;
const renderMILMessages = (baseDataResult, isEditionsSupported, appHasMultiInstanceEntitlement, selectedEditionType, enterprisePlanPurchased) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isEditionsSupported && selectedEditionType && enterprisePlanPurchased && appHasMultiInstanceEntitlement && /*#__PURE__*/_jsx(MultiInstancePricingSectionMessage, {
      enterprisePlan: enterprisePlanPurchased,
      selectedPlan: selectedEditionType.value,
      eligibleOfferings: baseDataResult.eligibleOfferings,
      isStepReviewAndInstall: false
    }), appHasMultiInstanceEntitlement && !isEditionsSupported && /*#__PURE__*/_jsx(SectionMessage, {
      appearance: "information",
      children: /*#__PURE__*/_jsx(BodySmall, {
        children: "This app is non-billable as it has already been purchased for multiple instances."
      })
    })]
  });
};
export const TwoClickAppInstallSiteAndPlanSelector = _ref => {
  var _installableApp$marke, _baseDataResult$hostD, _baseDataResult$avail, _baseDataResult$hostD2, _baseDataResult$hostD3;
  let {
    baseDataResult,
    appInstallConfig,
    selectedEditionType,
    setSelectedEditionType,
    isEditionsSupported,
    enterprisePlanPurchased,
    appHasMultiInstanceEntitlement
  } = _ref;
  const editions = (baseDataResult === null || baseDataResult === void 0 ? void 0 : baseDataResult.editions) || [];
  const editionsType = (editions === null || editions === void 0 ? void 0 : editions.map(edition => edition.type)) || [];
  const installMode = baseDataResult === null || baseDataResult === void 0 ? void 0 : baseDataResult.installMode;
  const installableApp = installMode === null || installMode === void 0 ? void 0 : installMode.installableApp;
  const isAppFree = isFreeApp(installableApp.marketplaceAppDetails.paymentModel);
  const links = useLinkTemplates({
    adminHubBaseUrl: appInstallConfig.adminHubBaseUrl,
    mpacBaseUrl: appInstallConfig.mpacBaseUrl,
    mpacCdnBaseUrl: appInstallConfig.mpacCdnBaseUrl,
    macBaseUrl: appInstallConfig.macBaseUrl,
    wacBaseUrl: appInstallConfig.wacBaseUrl,
    atlassianCommunityBaseUrl: appInstallConfig.atlassianCommunityBaseUrl
  });
  const appDetailsPricingLink = links.appPricingDetails.expand({
    appKey: installableApp === null || installableApp === void 0 ? void 0 : (_installableApp$marke = installableApp.marketplaceAppDetails) === null || _installableApp$marke === void 0 ? void 0 : _installableApp$marke.key
  });
  const hostCloudId = baseDataResult !== null && baseDataResult !== void 0 && (_baseDataResult$hostD = baseDataResult.hostData) !== null && _baseDataResult$hostD !== void 0 && _baseDataResult$hostD.hostInfo ? parseAri(baseDataResult.hostData.hostInfo.globalContext.id).cloudId : undefined;
  const filteredSite = baseDataResult === null || baseDataResult === void 0 ? void 0 : (_baseDataResult$avail = baseDataResult.availableSites) === null || _baseDataResult$avail === void 0 ? void 0 : _baseDataResult$avail.find(_ref2 => {
    let {
      cloudId
    } = _ref2;
    return cloudId === hostCloudId;
  });
  const appCompatibleProduct = baseDataResult === null || baseDataResult === void 0 ? void 0 : (_baseDataResult$hostD2 = baseDataResult.hostData) === null || _baseDataResult$hostD2 === void 0 ? void 0 : (_baseDataResult$hostD3 = _baseDataResult$hostD2.hostInfo) === null || _baseDataResult$hostD3 === void 0 ? void 0 : _baseDataResult$hostD3.product;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_ect418aq _1s6bukr8"]),
      children: [/*#__PURE__*/_jsx(ScreenTitle, {
        title: isEditionsSupported ? 'Select an edition and site' : 'Select a site',
        stepInfo: "Step 1 of 2"
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_3, _4, _5, _6]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_zulp1ejb _1e0c1txw _2lx21bp4 _19wgxy5q"]),
          children: [isEditionsSupported && selectedEditionType && setSelectedEditionType && /*#__PURE__*/_jsx(PlanSelector, {
            editions: editionsType.map(edition => ({
              label: edition,
              value: edition
            })),
            selectedPlanType: selectedEditionType,
            setSelectedPlanType: setSelectedEditionType,
            appPricingDetailsLink: appDetailsPricingLink
          }), /*#__PURE__*/_jsx(SiteSelectorSelect, {
            availableSites: filteredSite ? [filteredSite] : [],
            firstAppCompatibility: appCompatibleProduct,
            appInstallConfig: appInstallConfig,
            hostCloudId: hostCloudId || '',
            isFreeApp: isAppFree
          }), renderMILMessages(baseDataResult, isEditionsSupported, appHasMultiInstanceEntitlement, selectedEditionType, enterprisePlanPurchased), isEditionsSupported && /*#__PURE__*/_jsx(SandBoxSectionMessage, {
            eligibleOfferings: baseDataResult.eligibleOfferings,
            selectedEditionTypeValue: (selectedEditionType === null || selectedEditionType === void 0 ? void 0 : selectedEditionType.value) || null
          })]
        })]
      })]
    })]
  });
};